export const GET_BOT_ACCESS = 'GET_BOT_ACCESS';
